import type { DocPageContent } from '../docs-content'

const page = {
  order: 3,
  slug: 'projects',
  title: '项目',
  description: '创建、组织、导入、导出、删除和恢复项目。',
  category: '开始',
  sections: [
    {
      title: '项目生命周期',
      items: [
        '在项目页面创建新项目。',
        '编辑项目名称、描述、分辨率、帧率和背景颜色。',
        '需要变体而不改动原项目时，可复制项目。',
      ],
    },
    {
      title: '项目组织',
      items: [
        '搜索、排序和筛选项目列表。',
        '使用项目缩略图和元数据识别最近的编辑。',
        '使用活动工作区指示器确认项目的存储位置。',
      ],
    },
    {
      title: '回收站与项目包',
      items: [
        '永久删除前将项目移至回收站。',
        '在项目仍可用时从回收站恢复。',
        '在工作区之间迁移工作时，导出和导入项目包。',
      ],
    },
  ],
} satisfies DocPageContent

export default page